import type { ContractorsService } from "./service";
import { BaseRepository } from "../BaseRepository";
import type { IPaginated, IRepositoryOptions } from "@/types/common";
import type { AxiosRequestConfig } from "axios";
import type {
  IDeleteContractorRequest,
  IGetContractorProfileByUserIdRequest,
  IGetContractorsRequest,
  IUpdateContractorProfessionalDetailsRequest,
  IUpdateContractorRequest,
  IUpdateContractorServiceAreasRequest,
} from "./types";
import type { IContractor } from "@/types/users-contractors";
import type { IContractingCompany } from "@/types/companies-contractors";

export class ContractorsRepository extends BaseRepository {
  constructor(
    private readonly service: ContractorsService,
    options?: IRepositoryOptions,
  ) {
    super(options);
  }

  async getAll(
    p: IGetContractorsRequest,
    c?: AxiosRequestConfig,
  ): Promise<IPaginated<IContractor>> {
    const response = await this.handleRequest(this.service.getAll, p, c);
    return response.data;
  }

  async getContractingCompanies(
    c?: AxiosRequestConfig,
  ): Promise<IContractingCompany[]> {
    const response = await this.handleRequest(
      this.service.getContractingCompanies,
      c,
    );
    return response.data;
  }

  async deleteContractor(
    p: IDeleteContractorRequest,
    c?: AxiosRequestConfig,
  ): Promise<void> {
    await this.handleRequest(this.service.deleteContractor, p, c);
  }

  async updateProfile(
    p: IUpdateContractorRequest,
    c?: AxiosRequestConfig,
  ): Promise<IContractor> {
    const response = await this.handleRequest(this.service.updateProfile, p, c);

    return response.data;
  }

  async updateContractorServiceArea(
    p: IUpdateContractorServiceAreasRequest,
    c?: AxiosRequestConfig,
  ): Promise<IContractor> {
    const response = await this.handleRequest(
      this.service.updateContractorServiceArea,
      p,
      c,
    );

    return response.data;
  }

  async getProfileByUserId(
    p: IGetContractorProfileByUserIdRequest,
    c?: AxiosRequestConfig,
  ): Promise<IContractor> {
    const response = await this.handleRequest(
      this.service.getProfileByUserId,
      p,
      c,
    );
    return response.data;
  }

  async updateContractorProfessionalDetails(
    p: IUpdateContractorProfessionalDetailsRequest,
    c?: AxiosRequestConfig,
  ): Promise<IContractor> {
    const response = await this.handleRequest(
      this.service.updateContractorProfessionalDetails,
      p,
      c,
    );

    return response.data;
  }
}
